import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectName = (store: StoreSchema) => store.newApplicationState.newApplication.name